module.exports = __webpack_public_path__ + "static/media/login_image_1.ad3b6c4b.png";